import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
export function _useForceUpdate() {
  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      dispatch = _useState2[1];

  return useCallback(function () {
    return dispatch({});
  }, [dispatch]);
}
export function useHooksContainer(inst) {
  var _inst$__reactHooks__ = inst.__reactHooks__,
      stateKeys = _inst$__reactHooks__.stateKeys,
      refKeys = _inst$__reactHooks__.refKeys,
      effectKeysMap = _inst$__reactHooks__.effectKeysMap,
      memoKeysMap = _inst$__reactHooks__.memoKeysMap;

  var forceUpdate = _useForceUpdate();

  stateKeys.forEach(function (key) {
    var ref = useRef(inst[key]);
    Object.defineProperty(inst, key, {
      get: function get() {
        return ref.current;
      },
      set: function set(v) {
        ref.current = v;
        forceUpdate();
      }
    });
  });
  refKeys.forEach(function (key) {
    var ref = useRef(inst[key]);
    Object.defineProperty(inst, key, {
      get: function get() {
        return ref.current;
      },
      set: function set(v) {
        return ref.current = v;
      }
    });
  });
  effectKeysMap.forEach(function (depsFn, key) {
    var hookBody = inst[key].bind(inst);
    var deps = depsFn(inst);
    useEffect(function () {
      var returnValue = hookBody();
      return function () {
        if (typeof returnValue === 'function') {
          return returnValue();
        } else if (returnValue instanceof Promise) {
          return returnValue.then(function (cb) {
            return typeof cb === 'function' ? cb() : undefined;
          });
        }
      };
    }, deps);
  });
  memoKeysMap.forEach(function (depsFn, key) {
    var desc = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(inst), key);

    var _ref = desc !== null && desc !== void 0 ? desc : {},
        _ref$get = _ref.get,
        get = _ref$get === void 0 ? function () {} : _ref$get;

    var hookBody = get.bind(inst);
    var deps = depsFn(inst);
    var value = useMemo(function () {
      return hookBody();
    }, deps);
    Object.defineProperty(inst, key, {
      get: function get() {
        return value;
      },
      set: function set() {
        return false;
      }
    });
  });
  return inst;
}